import React, { useEffect, useState } from 'react'
import TopTitleBar from './TopTitleBar'
import Each from '../../../components/Each'
import { Link, useNavigate } from 'react-router-dom';
import { GET_DOCUMENT_FORM_FIELDS, GET_DOCUMENT_DRAFT_BY_ID, DELETE_DOCUMENT_DATA, USER_TOKEN, BASE_URL, PUBLISH_ALL } from '../../../Utils/constant'
import API from '../../../ApiConfig'
import Loader from '../../../components/Loader'
import _ from 'lodash'
import { AuthConsole, Delay, _ToNormal, isNumber } from '../../../Utils/helper';
import cogoToast from 'cogo-toast-react-17-fix';
import { pencil } from 'react-icons-kit/icomoon/pencil'
import { Icon } from 'react-icons-kit';
import useRefreshToken from '../../../Hooks/usegenerateToken';
import RecipientForm from './Issuer/RecipientForm';
import { arrow_right } from 'react-icons-kit/ikons/arrow_right';
import ErrorBoundary from '../../../components/ErrorBoundary';
import SlideUpWrapper from '../../../components/Transitions/SlideUpWrapper';
import ShimmerLoader from '../../../components/ShimmerLoader'
import Pagination from './Pagination';
import Breadcrumb from '../../../components/Verifier/breadcrumb/BreadCrumb';
import IssuerNavigator from '../../../components/DashBoard/IssuerNavigator';
import { useSelector } from 'react-redux';

const DATELABELS=["Date Of Joining", "Date Of Exit"]
const isDateOption=(item)=>
    typeof item.field_name=="string" && DATELABELS.includes(item.field_name)
export default function IssuerStep2({ doc, handleStep }) {
    useRefreshToken(BASE_URL + USER_TOKEN)
    const [activeItem, setActiveItem] = useState(null)
    const [loading, setLoading] = useState(false)
    const [fieldsData, setFieldsData] = useState([])
    const [list, setList] = useState([])
    const [addmore, setAddmore] = useState(false)
    const [deleting, setDeleting] = useState(null)
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const holder_data=JSON.parse(localStorage.getItem("holder_data"))
    const verifier_req_id=holder_data?.verifier_request_id
    const UserDetails=useSelector(state=>state.config)
    const navigate=useNavigate()
    
    // notification fields
    // const [notificationFields, setNotificationFields] = useState([])

    // const get_notification_fields = () => {
    //     setNotificationFields([
    //         {   "id": 10,
    //             "type": "string",
    //             "is_required": true,
    //             "placeholder": "Markov, Shane123",
    //             "field_name": "notification_info_email",
    //             "label": "notification_info_email",
    //             "isRequired": true,
    //             "fieldType": 1,
    //             "value": ""
    //         },
    //         {
    //             "id": 11,
    //             "type": "string",
    //             "is_required": true,
    //             "placeholder": "Markov, Shane123",
    //             "field_name": "notification_info_Name",
    //             "label": "notification_info_Name",
    //             "isRequired": true,
    //             "fieldType": 1,
    //             "value": ""
    //         },
    //         {
    //             "id": 12,
    //             "type": "string",
    //             "is_required": true,
    //             "placeholder": "Markov, Shane123",
    //             "field_name": "notification_info_phone_number",
    //             "label": "notification_info_phone_number",
    //             "isRequired": true,
    //             "fieldType": 1,
    //             "value": ""
    //         }

    //     ])
    // }

    // useEffect(() => {
    //     get_notification_fields()
    // }, [currentPage])

    const publishAll = async () => {
        setLoading(true)
        await Delay()
        let publish_all_url=`${PUBLISH_ALL}${doc.issuer_id}/${doc.id}`
        API.post(publish_all_url)
          .then(res => {
            let navigateto="/dashboard/Credentials"
            if (res.data.status === 200) {
              cogoToast.success(res.data.message)
              setTimeout(() => navigate(navigateto), 2000)
              // navigate("/dashboard/Credentials")
            }
          })
          .catch(err => {
            AuthConsole(err)
            setLoading(false)
    
          })
      }
    useEffect(() => {
        if (doc?.id)
            getFormFields()
    }, [])

    async function getDraftList(listData, loader) {
        if (loader) {
            setLoading(true)
            await Delay()
        }
        // if(holder_data?.verifier_request_id){
        //     return
        // }
        // else{
        API.get(GET_DOCUMENT_DRAFT_BY_ID + doc.issuer_id + '/' + doc.id, {
            params: {
                page: currentPage,
                status:"DRAFT"
            }
        })
            .then(res => {
                setLoading(false);
                if (res.data.status === 200) {
                    let { data } = res
                    let { data: { items }, data: { total_pages } } = data
                    setTotalPages(total_pages);
                    let oldList = []
                    items.map(item => {
                        if (item.details.issued_data_state === 'DRAFT') {
                            let draftItem = []
                            listData.map(field => {
                                let newField = { ...field }
                                newField.value = item.issued_data[field.field_name.toLowerCase().replace(/\s+/g,'_')]
                                newField.issued_uuid = item.details.issued_uuid
                                newField.notification_id = item.issued_data.notification_info_id
                                draftItem.push(newField)
                            })
                            const documentStateField = draftItem.find(
                                field => field.field_name === "Document State"
                            )
                            if(documentStateField?.value==="DRAFT"){
                                draftItem=draftItem.map(field=>field.field_name=="Reason For Hold"?{...field,isRequired:true}:field)
                            }
                            oldList.push(draftItem)
                        }
                    })
                    
                    setList(oldList)
                    setActiveItem(null)
                    setAddmore(false)
                }
            })
            .catch(err => {
                // debugger
                setLoading(false)
                if ((err.response && err.response.status === 403)) {
                    //cogoToast.error("Something Went Wrong")
                } else {
                    cogoToast.error("Something went wrong while fetching list!")
                }

            })
        // }
    }




    useEffect(()=>{
        if (fieldsData.length > 0) {
            getDraftList(fieldsData, true);
        }
    },[currentPage])
    function getFormFields() {
        // setLoading(true)
        const URL=GET_DOCUMENT_FORM_FIELDS + doc.id
        API.get(URL)
            .then(res => {
                setLoading(false)
                if (res.data.status === 200) {
                    // let listData = [...res.data?.data, ...notificationFields]
                    let listData = res.data?.data
                    listData.map(item => {
                        item.label = _ToNormal(item.field_name)
                        item.isRequired = item.is_required || false
                        item.fieldType = 1
                        item.value = item.value? item.value:""
                        item.fieldType = 1
                        if (isDateOption(item)){
                            item.fieldType=3
                        }
                    })
                    getDraftList(listData)
                    setFieldsData(listData)
                }
            })
            .catch(err => {
                setLoading(false)

            })
    }

    const handleAccordian = (index) => {
        if (index === activeItem)
            setActiveItem(null)
        else {
            setActiveItem(index)
            setAddmore(false)
        }
    }

    function getTableHeader(listItem) {
        let headers = []
        listItem.map((item, index) => {
            if (index < 3)
                headers.push(item.field_name)
        })
        return headers
    }

    async function deleteIssuedData(id, index) {
        setDeleting(index)
        await Delay()
        API.delete(DELETE_DOCUMENT_DATA + id)
            .then(res => {
                setDeleting(null)
                cogoToast.success('Removed Successfully!')
                getDraftList(fieldsData, true)
            })
            .catch(err => {
                setDeleting(null)
                cogoToast.error('Something went wrong!')
            })
    }

    const handleSubmitPrev = () => {
        if (list.length > 0) {
            handleStep(5);
        }
        else {
            cogoToast.error("Please save your details")
        }
    }
    useEffect(() => {
        setCurrentPage(1);
    }, [])
    const handlePageChange = (newPage) => {

        setCurrentPage(newPage);
    }

    const useTemplate = () => {

        const handleNavigate = (link) => {
            navigate(link)
        }
        return (
            list.length > 0 &&
            <div className="navItemContainer">
                <button className="btn btn-primary" onClick={e =>{UserDetails.bulk_upload_document_state_enabled?publishAll(): handleSubmitPrev()}} style={{ width: '10rem' }}>{UserDetails.bulk_upload_document_state_enabled?"Issue":"Preview & Issue"} <img src='/rightchevron.svg' loading='lazy' alt='rightchevron.svg' /></button>
            </div>
        )
    }
    return (
        <div style={{width:"100%"}}>
            <Loader isOpen={loading} />
            <Breadcrumb pos={3} title="Issue Document" category="issuer" />
            <SlideUpWrapper>

                <div className="issuer-background">
                    <IssuerNavigator
                        title="Add Recipient details"
                        handlestep={handleStep}
                        // step={"/dashboard/credentials"}
                        step={3}
                        actions={useTemplate}
                    />
                    {/* <TopTitleBar isChild >
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100vw' }}>
                        <h2 className="topTitleBarText"> <Link className="text-decoration-none" to="/dashboard/credentials">Documents</Link>
                            <span className="secondaryButton"> <Icon icon={arrow_right} /> Issue Documents</span> </h2>
                        <button onClick={e => handleSubmitPrev()} className='btn btn-primary' style={{ width: "fit-content" }}>Submit For Preview</button>
                    </div>
                </TopTitleBar> */}

                    {/* <div className="issuerSearchBar">
                    <div className="issuer-label-wrapper">
                        {doc?.doc_name ? <div className="issuer-label">{_ToNormal(doc.doc_name)}</div> : null}
                    </div>
                    {list.length > 0 ?
                        <div className="issuer-search-container">
                            <div className="issuer-input-container">
                                <div className="issuer-input-wrapper">
                                <img className="search-outline-icon5" loading="lazy" alt="" src="/searchoutline-2.svg" />
                                <input className="issuer-input" placeholder='Search' />
                            </div>
                            </div>
                        </div> : null}
                </div> */}

                    {list.length > 0 ?
                        // <div className='custom-table'>
                        //     <div className='custom-tr'>
                        //         <div className='custom-th flex-grow-1'><span className='pl-2'>UUID</span></div>
                        //         {getTableHeader(list[0]).map((keyItem, keyIndex) => {
                        //             return <div className='custom-th' key={keyIndex}> {_ToNormal(keyItem)}</div>
                        //         })}
                        //         <div className='custom-th text-c'>Action</div>
                        //     </div>
                        <Each of={list} render={(item, index) => {

                            return (
                                <>
                                    <div className='table-custom1' style={{ display: "flex" }} onClick={e => handleAccordian(index)}>
                                    <span className='pr-1 cursor-pointer' style={{ display: "flex", alignItems: "center", padding: "7px", marginRight: "10px" }}><img className={index === activeItem ? 'rt-180' : ''} loading="lazy" alt="" src="/chevrondown.svg" /></span>
                                        <div className='custom-table1'>
                                            <div className='custom-tr1'>
                                                {/* <div className='custom-th1'><span className='pl-2' style={{ borderRadius: "12px" }}>UUID</span></div> */}
                                                {getTableHeader(list[0]).map((keyItem, keyIndex) => {
                                                    return <div className='custom-th1' key={keyIndex}> {_ToNormal(keyItem)}</div>
                                                })}
                                                {/* <div className='custom-th1 text-c'>Action</div> */}
                                            </div>
                                            <div key={item[0].issued_uuid}>
                                                <div className='custom-tr1' style={{ animationDelay: `${index * 0.1}s` }} >

                                                    {/* <span className='pr-1 cursor-pointer' style={{paddingLeft:"10px"}}><img className={index === activeItem ? 'rt-180' : ''} loading="lazy" alt="" src="/chevrondown.svg" /></span> */}
                                                    {item.map((keyItem, keyIndex) => {
                                                        if (keyIndex > 2) return
                                                        return keyIndex == 0 ? <div className='custom-td' style={{ padding: "7px" }}>{keyItem.value}</div>
                                                            : <div className='custom-td' style={{ padding: "7px" }}>{keyItem.value}</div>
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                        <div className='custom-td text-c' style={{ display: "flex", alignItems: "center", padding: "7px", marginRight: "10px" }}>
                                            <span style={{ fontSize: 25 }} title='Edit' onClick={e => handleAccordian(index)} >
                                                <div className='custom-edit'><img loading='lazy' src='/pencil.svg' alt='pencil.svg' /> Edit</div>
                                            </span>
                                            <span className='ml-2' title='Delete' onClick={e => deleting ? {} : deleteIssuedData(item[0].issued_uuid, index)} >
                                                {deleting === index ? <span style={{ display: 'inline-block', verticalAlign: 'text-bottom' }}> <ShimmerLoader width='5rem' /> </span> : <div className='custom-edit'><img loading="lazy" alt="delete.svg" src="/delete.svg" /> Delete</div>}
                                            </span>
                                            <span className='ml-2' title='Issue Document' onClick={()=>{localStorage.setItem("docID",item[0].issued_uuid); handleStep(5)}} >
                                                {deleting === index ? <span style={{ display: 'inline-block', verticalAlign: 'text-bottom' }}> <ShimmerLoader width='5rem' /> </span> : <div className='custom-edit' style={{backgroundColor:"rgba(210, 224, 240, 0.699)", border:"1px solid lightgray"}}> Issue</div>}
                                            </span>
                                        </div>
                                    </div>
                                    <div className={index === activeItem ? 'custom-accordian show' : 'custom-accordian'}>
                                        <ErrorBoundary title="Recipient Form">
                                            <RecipientForm doc={doc} onUpdate={getDraftList} fieldsData={item} handleCancel={e => setActiveItem(null)} isIndex={index} />
                                        </ErrorBoundary>
                                    </div>
                                </>
                            )
                        }} /> : null
                    }
                    {
                        (list.length === 0 || addmore) && Object.keys(fieldsData).length > 0 && activeItem === null ?
                            <ErrorBoundary title="Recipient Form">
                                <RecipientForm doc={doc} onUpdate={getDraftList} handleCancel={e => list.length > 0 ? setAddmore(false) : {}} fieldsData={fieldsData} />
                            </ErrorBoundary> : null
                    }
                    {
                        list.length > 0 && activeItem === null && !addmore ? <div className='addMore-wrapper'>
                            <hr />
                            <button className='btn add-more1' onClick={e => setAddmore(true)} >+ Add</button>
                        </div> : null
                    }
                    <div style={{ marginTop: "1rem" }}>
                        <Pagination
                            nPages={totalPages}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            onPageChange={handlePageChange}
                            loading={loading}
                        />
                    </div>
                </div>
            </SlideUpWrapper>
        </div>
    )
}
